import CPreview from "./preview";
export default CPreview;
